<template>
  <div class="CTI_setting" :style="screenHeight">
    <div class="fixed_search">
      <div class="fixed_search_input">
        <Input v-model="queueName" placeholder="请输入技能组名称" title="技能组名称"/>
      </div>
      <div class="fixed_search_input">
        <Input v-model="queuePhone" placeholder="请输入技能组号码" title="技能组号码"/>
      </div>
      <div class="fixed_operation_btn">
        <Button type="primary" @click="initSearch">查询</Button>
        <Button type="info" class="operation_btn" @click="addQueue" v-if="roleList['3_5-2-1']">添加</Button>
      </div>
    </div>

    <div class="fixed_table">
      <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
      <el-table :data="infoTableList" style="width: 100%" :height="tableHeight" class="element_table" stripe @sort-change="sortChange" :cell-class-name="showColor" @selection-change="getSelectedId">
        <el-table-column v-for="(item,index) in fieldList" align="center" :show-overflow-tooltip='true' :type="item.type" :key="index" sortable="custom" :prop="item.key" :label="item.title">
          <template slot="header" slot-scope="scope">
            <el-tooltip  placement="top">
              <span style="overflow:hidden;text-overflow:ellipsis;white-space: nowrap;">{{item.title}}</span>
              <div slot="content" >
                <span>{{item.title}}</span>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column  fixed="right" label="操作" width="250" v-if="infoTableList.length>0"  align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="editQueue(scope.row.id)" v-if="roleList['3_5-2-2']">编辑</el-button>
            <el-button type="text" size="small" @click="deleteQueue(scope.row.id,scope.row.queuePhone)" v-if="roleList['3_5-2-3']">删除</el-button>
            <el-button type="text" size="small" @click="distributionQueue(scope.row.id)" v-if="roleList['3_5-2-4']">分配</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="page_style">
      <Page :total="total" size="small" :page-size='pageSize' :current='currentPage' :page-size-opts="pageSizeList" show-total show-sizer  @on-change="changeCurrent" @on-page-size-change="changeSize"/>
      <div style="padding-top: 2px;">跳至</div><Input class="show-elevator" v-model="speedChangePage" @on-blur="handleCurrentPage"/><div style="padding-top: 2px;">页</div>
    </div>
    <skillsGroupEditPop @closeSkillsGroup="closeSkillsGroup" :aiQueue="false" :showSkillsGroupEdit="showSkillsGroupEdit" :skillId="skillId" :title="title"></skillsGroupEditPop>
    <skillDistributionPop @closeDistribution="closeDistribution" :showDistribution="showDistribution" :skillId="skillId"></skillDistributionPop>
  </div>
</template>

<script>
  import {publicFunClass} from '@/components/js/PublicFunClass.js'
  import skillsGroupEditPop from '@/components/systemSetup/CTIConfigure/SkillsGroupEditPop.vue'
  import skillDistributionPop from '@/components/systemSetup/CTIConfigure/SkillDistributionPop.vue'
  export default {
    name: "SkillsGroup",
    mixins:[publicFunClass],
    components:{
      skillsGroupEditPop,
      skillDistributionPop
    },
    props:{
      pageCode:String
    },
    data(){
      return{
        showPageCount:0,
        spinShow:true,
        roleList: JSON.parse(localStorage.getItem("roleList")),
        configInfo: JSON.parse(localStorage.getItem("configInfo")),
        screenHeight:{height:''},
        tableHeight:600,
        title:'添加技能组',
        skillId:'',
        showSkillsGroupEdit:false,
        showDistribution:false,
        total:0,
        pageSizeList:[10,20,30,40,50,100,200],
        currentPage:1,
        speedChangePage: 1,
        pageSize:20,
        infoTableList:[],
        queuePhone:"",
        queueName:'',
        fieldList: [{key:'queueName',title:'技能组名称'},{key:'queuePhone',title:'技能组号码'},{key:'createTime',title:'更新时间'}],
        orderField:'',
        orderRule:'',
      }
    },
    methods:{
      initSearch:function () {
        this.spinShow=true;
        let that=this;
        let param={
          orderField:this.orderField,
          orderRule:this.orderRule,
          pageNum:this.currentPage,
          pageSize:this.pageSize,
          queuePhone:this.queuePhone,
          queueName:this.queueName,
          journalType:"null",
          menuId:"null",
          queueType:'0'
        };
        this.$http.post("skillGroup/toIndex.json",param) .then(function (res) {
          let result=res.data.flag;
          that.spinShow=false;
          if(result!="666"){
            that.$Modal.info({
              title:'提示',
              content:res.data.msg
            });
            return false;
          }
          that.infoTableList=res.data.obj.list.content;
          that.total=res.data.obj.list.totalSize;
        });
      },
      closeSkillsGroup:function(flag){
        this.showSkillsGroupEdit=false;
        if(flag){
          this.initSearch();
        }
      },
      addQueue:function () {
        this.showSkillsGroupEdit=true;
        this.skillId="";
        this.title='添加技能组';
      },
      editQueue:function (id) {
        this.showSkillsGroupEdit=true;
        this.skillId=id;
        this.title='编辑技能组';
      },
      deleteQueue:function (id,queuePhone) {
        let that=this;
        let param={
          id:id,
          queuePhone:queuePhone,
          journalType:"CTI配置=>技能组=>删除",
          menuId:"3_5-2-3"
        };
        this.$Modal.confirm({
          title: '提示',
          content: "是否确定删除",
          onOk: () => {
            that.$http.post("skillGroup/doDelete.json",param) .then(function (res) {
              let result=res.data.flag;
              if(result!="666"){
                that.$alert(res.data.msg, '提示', {
                  confirmButtonText: '确定'
                });
                return false;
              }
              that.$Message.info("技能组删除成功");
              that.initSearch();
            });
          }
        });
      },
      closeDistribution:function(){
        this.showDistribution=false;
      },
      distributionQueue:function (id) {
        this.showDistribution=true;
        this.skillId=id;
      },
      sortChange:function(event){
        if(event && event.order){
          if (event.prop == "queueName"){
            this.orderField = "queuename";
          }else if (event.prop == "queuePhone"){
            this.orderField = "queuenum";
          }else if (event.prop == "createTime"){
            this.orderField = "timestamp";
          }else{
            this.orderField="";
          }

          this.orderRule = event.order == "descending" ? "desc" : "asc";
        }else{
          this.orderField="";
          this.orderRule="";
        }
        this.initSearch();
      },
    },
    created(){
      this.screenHeight.height=this.mountHeight(91);
      let clientHeight=document.documentElement.clientHeight;
      this.tableHeight=clientHeight-185;
      this.initSearch();
    },
    watch:{
      pageCode:function () {
        if(this.pageCode=='3_5-2' && this.showPageCount==0){
          this.showPageCount++;

        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/systemSetup/CTIConfigure/SkillsGroup.vue